import React, { createContext, useState, useContext } from 'react';
import SnackBarMessage from './SnackBarMessage';
import CometChatSnackbar from './CometChatSnackbar';
// Create a Context for the Snackbar
const SnackbarContext = createContext();

// Custom hook to use Snackbar context
export const useSnackbar = () => useContext(SnackbarContext);

// SnackbarProvider component
export const SnackbarProvider = ({ children }) => {
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarDuration, setSnackBarDuration] = useState(2); // in seconds
  const [snackBarPosition, setSnackBarPosition] = useState({
    vertical: 'bottom',
    horizontal: 'left',
  });
  const [from, setFrom] = useState('')

  // Function to trigger Snackbar
  const triggerSnackbar = (
    message,
    durationInSeconds = 2,
    position = { vertical: 'bottom', horizontal: 'left' },
    from = ''
  ) => {
    setSnackBarMessage(message);
    setSnackBarDuration(durationInSeconds);
    setSnackBarPosition(position);
    setIsSnackbarOpen(true);
    setFrom(from);
  };

  return (
    <SnackbarContext.Provider value={{ triggerSnackbar }}>
      {children}
      {from === 'CometChat' ? (
        <CometChatSnackbar
          isSnackbarOpen={isSnackbarOpen}
          snackBarMessage={snackBarMessage}
          snackBarDuration={snackBarDuration}
          snackBarPosition={snackBarPosition}
          setIsSnackbarOpen={setIsSnackbarOpen}
        />
      ) : (
        <SnackBarMessage
          isSnackbarOpen={isSnackbarOpen}
          snackBarMessage={snackBarMessage}
          snackBarDuration={snackBarDuration}
          snackBarPosition={snackBarPosition}
          setIsSnackbarOpen={setIsSnackbarOpen}
        />
      )}
    </SnackbarContext.Provider>
  );
};
